.sidePanelContainer {
	background: var(--elevation-default);
	width: 440px;
	height: 100vh;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 1000;
	border-left: 1px solid var(--border-primary);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.header {
	height: fit-content;
	padding: 16px;
	align-content: center;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.body {
	flex: 1;
	overflow-y: auto;
	padding-inline: 16px;
	padding-bottom: 16px;
}

.footer {
	height: fit-content;
	border-top: 1px solid var(--border-primary);
	padding: 12px 16px;
	align-content: center;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
}
